import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useGame } from '../../../../../../../../contexts/GameContext'
import styles from './CannedMessages.module.css'
import { EditorFormField } from '../../../../../../../../common/components/Form/EditorFormField/EditorFormField'
import { useOnEscPress } from '../../../../../../../../hooks/useOnEscPress'
import { useDisableBodyScroll } from '../../../../../../../../hooks/useDisableBodyScroll'
import { useFadeAnimation } from '../../../../../../../../hooks/FadeAnimation/useFadeAnimation'
import { SmallModal } from '../../../../../../../../common/components/Modal/SmallModal'

type CannedMessageEditorProps = {
  onClose: () => void
  isGame: boolean
  initialId: number | null
  initialValue: string | null
}

export const CannedMessageEditor: React.FC<CannedMessageEditorProps> = ({
  onClose,
  isGame,
  initialId,
  initialValue,
}) => {
  const { t } = useTranslation()
  useOnEscPress(onClose)
  useDisableBodyScroll()
  const { closeWithDelay } = useFadeAnimation()

  const [toBeCannedValue, setToBeCannedValue] = useState('')
  const [toBeCannedId, setToBeCannedId] = useState<number | null>(null)
  const [initialToBeCannedValue, setInitialToBeCannedValue] = useState<string | null>(null)
  const { postCannedUserMessage, postCannedGameMessage } = useGame()

  useEffect(() => {
    setToBeCannedId(initialId)
    setInitialToBeCannedValue(initialValue)
    setToBeCannedValue(initialValue ?? '')
  }, [initialId, initialValue])

  const onCloseInternal = () => {
    closeWithDelay(350, onClose)
  }

  const handleSaveMessage = () => {
    if (toBeCannedValue && toBeCannedValue.trim().length !== 0) {
      if (isGame) postCannedGameMessage(toBeCannedId, toBeCannedValue)
      else postCannedUserMessage(toBeCannedId, toBeCannedValue)
    }
    setToBeCannedId(null)
    setToBeCannedValue('')
    setInitialToBeCannedValue('')
    onCloseInternal()
  }

  const handleSetToBeCannedValue = (text: string) => {
    setToBeCannedValue(text)
    if (text.trim().length === 0) {
      setToBeCannedId(null)
    }
  }

  return (
    <SmallModal
      onClose={onCloseInternal}
      iconName='text'
      headerText={t('canned_messages.create_header', 'Create feedback')}
      sendButtonText={t('canned_message.save_canned', 'Save feedback')}
      onSubmit={handleSaveMessage}
    >
      <h3 className={styles.editorHeading}>
        {t('canned_messages.input_label', 'Create of edit a feedback to be saved')}
      </h3>
      <EditorFormField
        initProps={{ height: 200 }}
        onlyBasicOptions
        name={'save message'}
        label={t('canned_messages.input_label', 'Create or edit a feedback to be saved')}
        srOnlyLabel={true}
        fieldContainerClassName={styles.fieldContainer}
        validateOnlyIfDirty
        onEditorChange={(value) => handleSetToBeCannedValue(value)}
        value={initialToBeCannedValue}
      />
    </SmallModal>
  )
}
